if (!customElements.get('my-reward-item')) {

    class MyRewardItem extends HTMLElement {

        myDiscounts = []
        discounts = []
        loading = false
        constructor(props) {
            super(props)
        }

        connectedCallback() {

            window.addEventListener('load', this.onWindowLoaded)


            this.renderState1()

        }

        disconnectedCallback() {
            window.removeEventListener('load', this.onWindowLoaded)

        }
        renderState1() {

            let isDisabled = this.myPoint < this.data.point;
            this.innerHTML = `      <div class="reward-item-container ${isDisabled ? "disabled" : ''}">
        <div class="reward-title-container">
          <div class="reward-title">${this.data.name}</div>
          <div class="reward-points">${this.data.point} Points</div>
        </div>
        <div class="redeem-btn-container">
          <button class="btn-getreward btn btn-sm">${window.rewardStrings.get_reward}</button>
        </div>
      </div>`

            this.getElementsByClassName("btn-getreward").item(0).addEventListener("click", () => {
                this.renderState2()
            })
        }

        renderState2() {
            this.innerHTML = `<div class="reward-item-container">
        <div class="reward-title-container">
          <div class="reward-title">Redeem Reward?</div>
        </div>
        <div class="redeem-btn-container">
          <button class="btn-cancle btn btn-sm text-red">${window.rewardStrings.cancel}</button>
          <button class="btn-redeem btn btn-sm">${window.rewardStrings.redeem}</button>
        </div>
      </div>`
            this.getElementsByClassName("btn-cancle").item(0).addEventListener("click", () => {
                this.renderState1()
            })
            this.getElementsByClassName("btn-redeem").item(0).addEventListener("click", () => {
                this.getElementsByClassName("btn-redeem").item(0).innerHTML = '<div class="icon-spin mx-auto d-inline-block"> </div>';
                this.getElementsByClassName("btn-redeem").item(0).disabled = true;
                this.onClickRedeem()
            })
        }
        copytoClipboard() {

            // Copy the text inside the text field
            navigator.clipboard.writeText(this.discountData.discount_code);

            // Alert the copied text
            // alert("Copied the text: " + this.discountData.discount_code);
            Toastify({
                text: window.rewardStrings.copy_to_clipboard,
                className: "success",
                gravity: "bottom",
                position: "right",
                style: {
                    background: "#d2ff02",
                    color: "#000"
                }
            }).showToast();
        }
        renderState3() {
            this.innerHTML = `<div class="d-flex flex-column justify-content-center align-items-center">
                <div class="box-discount-title">You've got ${this.discountData.reward_info.name}</div>
                <div class="d-flex flex-row box-discount">
                    <div class="discount-code">${this.discountData.discount_code}</div>
                   <button  class="btn-copy-discount"    onclick="copyToClipboard('${this.discountData.discount_code}')"><svg width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"/></svg></button>
                </div>
          </div>`
            this.getElementsByClassName("btn-copy-discount").item(0).addEventListener("click", () => {
                this.copytoClipboard()
            })
        }
        async onClickRedeem() {
            this.getElementsByClassName("btn-redeem").item(0).classList.add("loading")
            var token = await window.getToken();
            var res = await fetch(`${window.BackendUrl}/customer/reward/redeem`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ rewardID: this.data.id })
            })
            var response = await res.json();
            this.getElementsByClassName("btn-redeem").item(0).classList.remove("loading")

            if (response && response.success) {
                this.discountData = response.body.data;
                this.updateMyPoint(response.body.customer.reward_point)
                this.renderState3();

                StoreFrontAPI.instance.applyDiscount(this.discountData.discount_code).then(res => {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
                })
                this.classList.add("redeemed")
                var parentReward = document.getElementById(this.parentID)
                parentReward.showCodeRedemmed(this);


            } else {
                var elements = document.getElementsByTagName("my-rewards")
                for (let index = 0; index < elements.length; index++) {
                    const element = elements.item(index)
                    element.getListReward();
                }
            }

        }
        updateMyPoint(point) {
            var elements = document.getElementsByClassName("my-reward-point")
            for (let index = 0; index < elements.length; index++) {
                const element = elements.item(index);
                element.textContent = point > 1 ? `${point} ${window.rewardStrings.hero_points}` : `${point} ${window.rewardStrings.hero_point}`

            }
        }
        getLoadingIcon() {
            return `<svg class="fa-spin" width="15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" /></svg>`
        }

        onWindowLoaded = () => {
            requestAnimationFrame(() => {

                this.init()
            })
        }

        toNodes = (html) => new DOMParser().parseFromString(html, 'text/html').body.childNodes[0];


    }

    customElements.define(
        'my-reward-item',
        MyRewardItem
    );

}
